import { render } from "./PublishOrIAModal.vue?vue&type=template&id=52135a68"
import script from "./PublishOrIAModal.vue?vue&type=script&lang=js"
export * from "./PublishOrIAModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__